export default __webpack_public_path__ + "static/media/Links.d19df094.xml";